module.exports = __webpack_public_path__ + "static/media/TATACONSUM.f86c115a.txt";